import { environment } from '@lla-platform/core/core-util'

export const REVIEWS_API_URL = {
  checkToekn: `${environment.apiUrl}/reviews/auth-code`,
  getReviews: `${environment.apiUrl}/reviews`,
  replySugestion: `${environment.apiUrl}/reviews/reply-sugestion`,
  replyReview: `${environment.apiUrl}/reviews/reply`,
  googleReviewsSummary: `${environment.apiUrl}/google-reviews/locations/detail`,
  googleReviewsDetail: (locationId: string) =>
    `${environment.apiUrl}/google-reviews/location/${locationId}`,
  googleReviewsTrends: `${environment.apiUrl}/google-reviews/locations/trends`
}
